import React, { ReactNode, useState } from 'react';
import { ModalWindow, useDeviceType } from '@cian/ui-kit';

import { FAQBlock } from '../../components/FAQBlock';
import { Section } from '../../components/Section';
import { H2 } from '../../components/H2';
import { FAQBlocksLayout } from '../../components/FAQBlocksLayout';
import { getFAQBlocks } from './constants/FAQBlocks';
import { FAQModalContainer } from '../FAQModalContainer';
import { trackOpenFaqModalClick } from './tracking';
import { useApplicationContext } from '../../utils/applicationContext';

export interface IFAQQuestion {
  question: string;
  answer: string | ReactNode;
}

export interface IFAQBlock {
  name: string;
  questions: IFAQQuestion[];
}

export const FAQSectionContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const isAbsolutBankEnabled = config.getStrict<boolean>('e2e-reference.OnlineMeetingAbsolutBank.Enabled');

  const [displayedFaqBlockInModal, setDisplayedFaqBlockInModal] = useState<IFAQBlock | null>(null);
  const onFAQBlockClick = (block: IFAQBlock) => () => {
    setDisplayedFaqBlockInModal(block);
    trackOpenFaqModalClick(block.name);
  };
  const onModalClose = () => setDisplayedFaqBlockInModal(null);

  const isMobile = useDeviceType() === 'phone';

  return (
    <Section testId="FAQSection">
      <H2>Часто задаваемые вопросы</H2>
      <FAQBlocksLayout>
        {getFAQBlocks({ isAbsolutBankEnabled }).map((block, i) => (
          <FAQBlock
            key={i}
            name={block.name}
            questionsCount={block.questions.length}
            onClick={onFAQBlockClick(block)}
          />
        ))}
      </FAQBlocksLayout>
      <ModalWindow
        open={Boolean(displayedFaqBlockInModal)}
        onClose={onModalClose}
        title={displayedFaqBlockInModal?.name}
        height={isMobile ? '100%' : 'auto'}
        content={displayedFaqBlockInModal && <FAQModalContainer {...displayedFaqBlockInModal} />}
      />
    </Section>
  );
};
